/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import People from './people.component';
import {
  errorfetchingPeople,
  publishPeopleCount,
  receiveOrganizations,
  requestOrganizations
} from '../../actions/actions';
import RequestService from '../../service/requestService';

export const mapStateToProps = (state) => {
  return {
    sponsor: state.sponsor.selectedSponsor,
    error: state.people.errorPeople,
    organizations: state.people.organizations,
    totalOrganizations: state.people.totalOrganizations,
    isFetching: state.people.isFetching,
    isParticipant: state.login.user.isParticipant,
    hiredOrgGid: state.login.user.hiredOrganization && state.login.user.hiredOrganization.organizationGid
  };
};

const fetchOrganizations = (dispatch) => (sponsor, isParticipant, offset, limit) => {
  return new Promise((resolve, reject) => {
    dispatch(requestOrganizations());

    return RequestService.getPeopleBySponsor(sponsor, isParticipant, offset, limit)
      .then((response) => {
        dispatch(receiveOrganizations(response.data));
        dispatch(publishPeopleCount(response.data));
        resolve(response.data);
      })
      .catch((error) => {
        dispatch(errorfetchingPeople(error));
        reject(error);
      });
  });
};

const CPeople = connect(mapStateToProps, (dispatch) => ({ fetchOrganizations: fetchOrganizations(dispatch) }))(People);

export default CPeople;
